import { all, fork } from "redux-saga/effects";

import accountsSaga from "./accounts/saga";
import clientsSaga from "./ib/clients/saga";
import requests from "./requests/saga";
import ibSaga from "./ib/sagas";
import fetchProfilesSaga from "./mamProfile/saga";
import cpSaga from "./cp/sagas";

export default function* forexSaga() {
  yield all([
    fork(ibSaga),
    fork(accountsSaga),
    fork(clientsSaga),
    fork(requests),
    fork(fetchProfilesSaga),
    fork(cpSaga),
  ]);
}
